<template>
	<div style="positon: absolute">
		<i class="fa fa-search icone-busca" aria-hidden="true"></i>
		<i class="fa fa-refresh fa-spin icone-buscando" v-show="buscando" aria-hidden="true"></i>
		<input
			type="text"
			:placeholder="_traducao('global', 'buscar')"
			v-model="busca"
			@input="
				$emit('tabela-filtra', $event.target.value)
				$refs.input.focus()
			"
			ref="input"
			class="form-control"
		/>

		<a
			href="#"
			v-show="busca != '' && !buscando"
			@click="
				busca = ''
				$emit('tabela-filtra', '')
			"
		>
			<i class="fa fa-times icone-limpar" aria-hidden="true"></i>
		</a>
	</div>
</template>
<script>
export default {
	props: {
		buscando: {
			type: Boolean,
			require: false,
			default: false
		}
	},

	data() {
		return {
			busca: ''
		}
	}
}
</script>

<style scoped>
input {
	padding-left: 25px;
}
.icone-busca {
	position: absolute;
	top: 10px;
	left: 22px;
	color: #999;
	z-index: 0;
}

.icone-buscando {
	position: absolute;
	top: 10px;
	right: 22px;
	color: #999;
	z-index: 0;
}

.icone-limpar {
	position: absolute;
	top: 10px;
	right: 22px;
	color: #999;
	z-index: 0;
}
</style>